import { getHeaderHeight } from '../scroll-to-element';

// desktop: grupy filtrow (.filter-groups, bez naglowka "Filtry") przyklejone w kolumnie pod naglowkiem
// sklepu. Gdy lista jest wyzsza niz ekran, jedzie razem ze strona i przykleja sie dopiero, gdy pokaze
// swoj dol; w gore odwrotnie - az pokaze gore. Steruje tym `top` przy position: sticky (CSS w atf_listing).
const desktopQuery = window.matchMedia('(min-width: 1280px)');
const GAP = 20;

let lastScrollY = window.scrollY;
let currentTop = null;
let frame = null;
let observed = null;

const resizeObserver = typeof ResizeObserver === 'function'
    ? new ResizeObserver(() => schedule(true))
    : null;

function update(resetDelta) {
    frame = null;

    const groups = document.querySelector('#filter-mount .filter-groups');
    const delta = resetDelta ? 0 : window.scrollY - lastScrollY;
    lastScrollY = window.scrollY;

    if (!groups || !desktopQuery.matches) return;

    // grupy zwijaja sie i rozwijaja - zmiana wysokosci przelicza polozenie
    if (resizeObserver && observed !== groups) {
        if (observed) resizeObserver.unobserve(observed);
        resizeObserver.observe(groups);
        observed = groups;
    }

    const stickTop = getHeaderHeight() + GAP;
    const bottomTop = Math.min(stickTop, window.innerHeight - groups.offsetHeight - GAP);

    if (currentTop === null) currentTop = stickTop;
    currentTop = Math.max(bottomTop, Math.min(stickTop, currentTop - delta));

    groups.style.top = `${Math.round(currentTop)}px`;
}

function schedule(resetDelta) {
    if (frame) return;
    frame = requestAnimationFrame(() => update(resetDelta));
}

export default function () {
    window.addEventListener('scroll', () => schedule(false), { passive: true });
    window.addEventListener('resize', () => schedule(true));
    desktopQuery.addEventListener('change', () => schedule(true));

    // kolumna dociaga sie asynchronicznie, a pjax wpina ja z powrotem po kazdej podmianie listingu
    document.addEventListener('pjax:complete', () => schedule(true));
    document.addEventListener('filters:ready', () => schedule(true));

    schedule(true);
}
